/**
 * Utilidad para manejar URLs de imágenes de propiedades
 * Maneja tanto URLs de Cloudinary como URLs locales
 */

export const getImageUrl = (foto, defaultFallback = true) => {
  if (!foto) {
    return defaultFallback ? `${window.location.origin}/Orsan/default.jpg` : '';
  }
  
  if (Array.isArray(foto)) {
    // Si es un array, tomar la primera foto
    return foto[0] || (defaultFallback ? `${window.location.origin}/Orsan/default.jpg` : '');
  }
  
  if (typeof foto === 'string') {
    const fotoTrimmed = foto.trim();
    if (fotoTrimmed.startsWith('http')) {
      // Es una URL completa (Cloudinary u otra externa)
      return fotoTrimmed;
    } else {
      // Es una URL local
      return `${window.location.origin}/Orsan/${fotoTrimmed}`;
    }
  }
  
  return defaultFallback ? `${window.location.origin}/Orsan/default.jpg` : '';
};

export const getFirstImageUrl = (fotos, defaultFallback = true) => {
  if (!fotos) {
    return defaultFallback ? `${window.location.origin}/Orsan/default.jpg` : '';
  }

  if (Array.isArray(fotos)) {
    // Si es un array de URLs, retornar la primera
    return fotos[0] || (defaultFallback ? `${window.location.origin}/Orsan/default.jpg` : '');
  }

  if (typeof fotos === 'string') {
    // Si es una cadena, podría ser una lista separada por comas o una sola URL
    const fotosArray = fotos.split(',').map(f => f.trim()).filter(Boolean);
    return getImageUrl(fotosArray[0] || '', defaultFallback);
  }

  return defaultFallback ? `${window.location.origin}/Orsan/default.jpg` : '';
};

export const getAllImageUrls = (fotos) => {
  if (!fotos) return [];
  
  if (Array.isArray(fotos)) {
    return fotos;
  }
  
  if (typeof fotos === 'string') {
    return fotos.split(',')
      .map(foto => foto.trim())
      .filter(foto => foto.length > 0)
      .map(foto => getImageUrl(foto, false));
  }
  
  return [];
};